// extracted by mini-css-extract-plugin
export default {"page":"Common_page__6acQt","red":"Common_red__cKgKu"};